import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../../shared/makeApiCall";
import SpecTestForm from "../../../components/forms/setup/specSheet/SpecTestForm";
import { BannerNotificationType } from "../../../components/SimpleNotification";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { updateObjectInArray } from "../../../shared/utility";

export function SpecSheetTestsViewModel(logout) {
  const [loading, setLoading] = useState(false);
  const [specTests, setSpecTests] = useState({
    data: [],
  });
  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const getSpecTests = async function (search, page) {
    setLoading(true);

    let callResult = await makeGetApiCall(
      `specSheetTests?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setSpecTests(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createSpecTest = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("specSheetTests/create", payload);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Spec sheet test added",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getSpecTests("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateSpecTest = async function (values, index) {
    let callResult = await makePutApiCall(
      `specSheetTests/${values.id}`,
      values
    );

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Spec sheet test updated",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });

      const currentItems = [...specTests.data];
      var payload = {
        index: index,
        item: callResult.data.item,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setSpecTests({ ...specTests, data: newItems });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddSpecTestSlideOver = (isEdit, specTest, index) => {
    setSlideOver({
      childComponent: (
        <SpecTestForm
          specTest={specTest}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit ? updateSpecTest(payload, index) : createSpecTest(payload)
          }
          title={isEdit ? `Update ${specTest.name}` : "Add new specTest"}
        />
      ),
      open: true,
    });
  };

  const deleteSpecTest = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteSpecSheetTest/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = specTests.data.filter((item) => item.id !== id);
      setSpecTests({ ...specTests, data: newItems });

      setShowSimpleNotification({
        show: true,
        title: callResult.data.message,
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteSpecTest = function (specTest, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          hideReason={true}
          confirmAction={() => deleteSpecTest(specTest.id, index)}
          message={`Are you sure you want to delete  ${specTest.name}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  return {
    openAddSpecTestSlideOver,
    getSpecTests,
    loading,
    specTests,
    setSlideOver,
    slideOver,
    setShowSimpleNotification,
    showSimpleNotification,
    setEmptyModelOpen,
    emptyModal,
    askDeleteSpecTest,
  };
}
